import { render, staticRenderFns } from "./chooseTypeDrawe.vue?vue&type=template&id=74b40acb&scoped=true&"
import script from "./chooseTypeDrawe.vue?vue&type=script&lang=js&"
export * from "./chooseTypeDrawe.vue?vue&type=script&lang=js&"
import style0 from "./chooseTypeDrawe.vue?vue&type=style&index=0&id=74b40acb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b40acb",
  null
  
)

export default component.exports